module.exports = require('./src/html-tagged-template-literal.js')
